import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class HelpPage extends Phaser.GameObjects.Container {
  /**
   * This full screen page is placed at the center of the screen. It should not be moved.
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, scene.scale.width / 2, scene.scale.height / 2);

    this.bg = this.scene.add.rectangle(0,0,this.scene.scale.width, this.scene.scale.height, 0x000000, 0.75);
    this.add(this.bg);

    // make the full container interactive
    ABCyaPhaser.Container.setContainerInteractive(this, false);

    this.headerText = ABCyaPhaser.Text.addText(0,-296,46, 0xf9edbb, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('help_popup.header'), this, true).setShadow(-3,3, '#00000060', 1)
      .setWordWrapWidth(535)
      .setPadding(4,4);

    this.amBg = ABCyaPhaser.Images.addImage(38,-113,UIAssetKeys._AMPM_Bg, this);
    this.pmBg = ABCyaPhaser.Images.addImage(38,139,UIAssetKeys._AMPM_Bg, this);
    this.sun = ABCyaPhaser.Images.addImage(-306,-106,UIAssetKeys._SunPopup, this);
    this.moon = ABCyaPhaser.Images.addImage(-268,146,UIAssetKeys._MoonPopup, this);

    this.amHeader = ABCyaPhaser.Text.addText(101,-163,44, 0x232323, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('help_popup.am_section.header'), this, true);
    this.amBody = ABCyaPhaser.Text.addText(101,-93,30, 0x232323, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('help_popup.am_section.body'), this, true).setWordWrapWidth(560);

    this.pmHeader = ABCyaPhaser.Text.addText(101,87,44, 0x232323, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('help_popup.pm_section.header'), this, true);
    this.pmBody = ABCyaPhaser.Text.addText(101,159,30, 0x232323, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('help_popup.pm_section.body'), this, true).setWordWrapWidth(560);
  }
}